import {BaseContainerModel} from '../../base-container.model';
import {bl_aat_claim_cycle_review_history_RowClass} from '../../../dbschema';

export class ClaimCycleReviewHistoryContainerModel extends BaseContainerModel {
  bl_aat_claim_cycle_review_history: bl_aat_claim_cycle_review_history_RowClass = new bl_aat_claim_cycle_review_history_RowClass();
}
